import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import TrueLinkIcon from 'react/shared/components/true_link/main/TrueLinkIcon';
import PALETTE from 'react/shared/theme/palette';

const useStyles = makeStyles({
  icon: {
    marginTop: '3px',
  },
});

export default function SecurityInfo() {
  const classes = useStyles();

  return (
    <Grid container spacing={1} wrap="nowrap">
      <Grid classes={{ root: classes.icon }} item>
        <TrueLinkIcon icon="lock" style={{ color: PALETTE.emerald }} />
      </Grid>
      <Grid item>
        <CardText>We secure your data with a 2048-bit key size encryption.</CardText>
      </Grid>
    </Grid>
  );
}
